import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=8175a2a0&scoped=true"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=8175a2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8175a2a0",
  null
  
)

export default component.exports